"use client";

import autoplay from "embla-carousel-autoplay";

import { PrimHeroCarousel } from "@/shared-web.ui/prim.hero-carousel";
import { HardLink } from "@/shared-web.ui/ui.link";
import {
  type BlogDetailHeadProps,
  PrimBlogDetailHead,
} from "@/stf.ui/prim.blog-detail-head";

interface BlogHeroSlideProps {
  heroList: BlogDetailHeadProps[];
}
const BlogHeroSlide = (props: BlogHeroSlideProps) => {
  return (
    <PrimHeroCarousel.Provider
      opts={{
        loop: true,
      }}
      plugins={[
        autoplay({ playOnInit: true, delay: 8000 }),
      ]}
      className="shadow-5 rounded-4"
    >
      <PrimHeroCarousel.Content
        overflowClassName="rounded-b-4"
      >
        {props.heroList.map((hero) => {
          return (
            <PrimHeroCarousel.Item key={hero.slug}>
              <PrimBlogDetailHead.ButtonContainer>
                <HardLink href={`/blog/${hero.slug}`}>
                  <PrimBlogDetailHead.Button>
                    <PrimBlogDetailHead.Content {...hero} />
                  </PrimBlogDetailHead.Button>
                </HardLink>
              </PrimBlogDetailHead.ButtonContainer>
            </PrimHeroCarousel.Item>
          );
        })}
      </PrimHeroCarousel.Content>
    </PrimHeroCarousel.Provider>
  );
};

export { BlogHeroSlide };
